import React from 'react'
import { Box, SectionHeading } from '../ui'

const LayoutSection = ({
  heading, action = null, headingAs, children, ...props
}) => (
  <Box
    mb={3}
    {...props}
  >
    {
      heading
        ? (
          <SectionHeading
            mb={3}
            as={headingAs}
            action={action}
          >
            {heading}
          </SectionHeading>
        ) : null
    }
    <Box pb={2}>
      {children}
    </Box>
  </Box>
)

export default LayoutSection
